export default __webpack_public_path__ + "static/media/battery-50.53d62ec3.svg";